import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent } from '../../schema'

type Assignment = OpalApiComponent<'V2', 'assignment'>

type Attributes = {
  stageId: string
  position: number
  type: 'approval' | 'task' | 'circuit_breaker'
}

const defaultAttributes: Omit<
  OpalApiComponent<'V2', 'assignment'>['attributes'],
  'assignment_type' | 'position' | 'metadata'
> = {
  created_at: 'unsaved',
  updated_at: new Date().toISOString(),
  deleted_at: null,
}

export const resourceObject = ({
  stageId,
  position,
  type,
}: Attributes): Assignment => ({
  id: `placeholder-${uuidv4()}`,
  type: 'assignment',
  attributes: {
    assignment_type: type,
    position,
    metadata: null,
    ...defaultAttributes,
  },
  relationships: {
    stage: {
      data: { id: stageId, type: 'stage' },
    },
    assigned_user: { data: null },
    created_by_user: { data: { id: uuidv4(), type: 'user' } },
    responses: { data: [] },
  },
})
